module.exports = __webpack_public_path__ + "fe2148eea5ef39a3086f07eafa842e44.png";